<template>
    <v-layout class="component-wrap">
        <ideasBank />
    </v-layout>
</template>

<script>
import ideasBank from '@/components/view_blocks/Ideas_bank/Ideas_bank_wrap';

export default {
  components: {
    ideasBank,
  },
};
</script>

